import React from "react";
import { Box, useMediaQuery } from "@mui/material";
import GoogleAd from "./GoogleAd";
import { isNativeBannerAvailable, useNativeBanner } from "../utils/nativeAds";
import { PAGE_CONTENT_MAX_WIDTH } from "../pageLayout";

// Anuncio vertical fijo en el margen derecho, al costado del contenido
// centrado (PAGE_CONTENT_MAX_WIDTH). Va dentro del Container de la página con
// `position: relative`: se ubica justo a la derecha y queda sticky al hacer
// scroll. `pt` alinea el anuncio con el contenido de la página. Solo se monta si sobra lugar a la derecha; si no, no se renderiza
// (un <ins> con ancho 0 hace fallar el push de AdSense).
const GAP = 24;
const railQuery = (width) =>
  `(min-width:${PAGE_CONTENT_MAX_WIDTH + 2 * (width + GAP + 16)}px)`;

// Ancho del anuncio lateral que entra a la derecha (300 o 160), o 0 si no
// hay lugar. GoogleAdInline lo usa para mostrarse justo cuando este no.
// noSsr: sin esto useMediaQuery devuelve false en el primer render y se
// llega a montar (y hacer push de) un bloque que se desmonta enseguida, lo
// que AdSense reporta como "No slot size for availableWidth=0".
export const useSideRailWidth = () => {
  const fitsWide = useMediaQuery(railQuery(300), { noSsr: true });
  const fitsNarrow = useMediaQuery(railQuery(160), { noSsr: true });
  if (fitsWide) return 300;
  return fitsNarrow ? 160 : 0;
};

const GoogleAdSideRail = ({ top = 96, pt = { xs: 6, md: 10 } }) => {
  const width = useSideRailWidth();
  // En la app Android el anuncio es el banner nativo de AdMob.
  const inApp = isNativeBannerAvailable();
  useNativeBanner(inApp);
  if (inApp || !width) return null;

  return (
    <Box
      component="aside"
      sx={{ position: "absolute", top: 0, bottom: 0, left: "100%", ml: `${GAP}px`, pt, width }}
    >
      <Box sx={{ position: "sticky", top }}>
        <GoogleAd key={width} format="vertical" fullWidthResponsive={false} sx={{ my: 0 }} />
      </Box>
    </Box>
  );
};

export default GoogleAdSideRail;
